export const memberRouter = [
    {
        path: '',
        redirect: 'index'
    },
    {
        path: 'index',
        meta: {
            title: '首页',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/member/page/index'),
    },
    {
        path: '/mobile/index',
        meta: {
            title: '首页',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/mobile/member/page/index'),
    },
    {
        path: 'ship',
        meta: {
            title: '会员说明',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/member/page/ship'),
    },
    {
        path: 'notice',
        meta: {
            title: '通知公告',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/member/page/notice'),
    },
    {
        path: 'active',
        meta: {
            title: '机构动态',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/member/page/active'),
    },
    {
        path: 'metting',
        meta: {
            title: '活动会议',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/member/page/metting'),
    },
    {
        path: 'service/list',
        meta: {
            title: '服务中心',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/member/page/service/list'),
    },
    {
        path: 'service/detail',
        meta: {
            title: '服务详情',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/member/page/service/detail'),
    },
    {
        path: 'service/record',
        meta: {
            title: '申请记录',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/member/page/service/record'),
    },
    {
        path: 'vip',
        component: () => import('../views/member/page/vip/home'),
        children: [
            {
                path: '',
                redirect: 'basic'
            },
            {
                path: 'basic',
                meta: {
                    title: '基本信息',
                    needLogin: true // 是否需要登录才能访问
                },
                component: () => import('../views/member/page/vip/basic'),
            },
            {
                path: 'certificate',
                meta: {
                    title: '会员证书',
                    needLogin: true // 是否需要登录才能访问
                },
                component: () => import('../views/member/page/vip/certificate'),
            },
            {
                path: 'ship',
                meta: {
                    title: '会费及发票信息',
                    needLogin: true // 是否需要登录才能访问
                },
                component: () => import('../views/member/page/vip/ship'),
            }
        ]
    },
    {
        path: 'account',
        meta: {
            title: '账号设置',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/member/page/account'),
    },
    {
        path: 'password',
        meta: {
            title: '修改密码',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/member/page/password'),
    },
    {
        path: 'call',
        component: () => import('../views/member/page/call/home'),
        children: [
            {
                path: '',
                redirect: 'intro'
            },
            {
                path: 'intro',
                meta: {
                    title: '机构介绍',
                    needLogin: true // 是否需要登录才能访问
                },
                component: () => import('../views/member/page/call/intro'),
            },
            {
                path: 'contact',
                meta: {
                    title: '联系我们',
                    needLogin: true // 是否需要登录才能访问
                },
                component: () => import('../views/member/page/call/contact'),
            },
            {
                path: 'idea',
                meta: {
                    title: '意见建议',
                    needLogin: true // 是否需要登录才能访问
                },
                component: () => import('../views/member/page/call/idea'),
            }
        ]
    },
    {
        path: 'payment',
        meta: {
            title: '会员续费',
            needLogin: true // 是否需要登录才能访问
        },
        component: () => import('../views/member/page/payment'),
    },
]

export default memberRouter
